module.exports = __webpack_public_path__ + "img/ordTNiac3.c080764a.jpg";